export default "__VITE_ASSET__Bfz5KL3y__"